import React, { useEffect } from 'react';
import remark from 'remark';
import remark2react from 'remark-react';
import './ApiDetails.css';
import BundleApisGrid from './BundleApisGrid';

const ApiOverview = ({ content,bundleDetailsViewEnabled,bundleApis }) => {
  //set scroll To top when component unmounts
  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);
  return (
    <div>
      <div className="api-dir-pkg_overview-heading">Description</div>
      <div className="api-dir-pkg_api-description" data-cy="api-description">
        {content && content.length ? (
          remark()
            .use(remark2react, {
              remarkReactComponents: {
                p: DescriptionContent,
                a: StyledAnchor,
                h1: DescriptionHeader,
                h2: DescriptionHeader,
                h3: DescriptionHeader,
                h4: DescriptionHeader,
              },
            })
            .processSync(content).contents
        ) : (
          <div className="api-dir-pkg_api-description-message">
            The provider does not have any overview available at this time.
          </div>
        )}
      </div>
      {bundleDetailsViewEnabled && (
        <BundleApisGrid
          bundleApis={bundleApis}
        />
      )}
    </div>
  );
};
const DescriptionHeader = props => (
  <h2 className="api-dir-pkg_description-header">{props.children}</h2>
);
const DescriptionContent = props => (
  <p className="api-dir-pkg_description-content">{props.children}</p>
);
const StyledAnchor = props => (
  <a className="api-dir-pkg_styled-anchor" {...props}>
    {props.children}
  </a>
);

export default ApiOverview;
